import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { noop } from 'ui-components/default-props/noop';

const messages = defineMessages({
  title: {
    description: 'Invoices Placeholder Title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'UXFu+r',
  },
  description: {
    description: 'Invoices Placeholder Description',
    defaultMessage: 'No Invoices to view at the moment',
    id: '+0BygA',
  },
  boldStatusView: {
    description: 'Invoices Placeholder Bold Status View Name',
    defaultMessage: 'Invoices',
    id: 'qGKvTt',
  },
});

const InvoicesGridPlaceholder = () => {
  return (
    <ActionablePlaceholder
      action={noop}
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default InvoicesGridPlaceholder;
